module.exports = __webpack_public_path__ + "media/assets/icon_message-3086b99c44676e698ee5c9e5b2535a3cc7e0154f32a8f1eceb0ef3346d62cab0.svg";